import { render, staticRenderFns } from "./AccessTokenList.vue?vue&type=template&id=06ee1f8e&scoped=true"
import script from "./AccessTokenList.vue?vue&type=script&lang=js"
export * from "./AccessTokenList.vue?vue&type=script&lang=js"
import style0 from "./AccessTokenList.vue?vue&type=style&index=0&id=06ee1f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ee1f8e",
  null
  
)

export default component.exports